const formatSystemApiRelativeUrl = (projectSlug) => `/system/${projectSlug}`;
export {
  formatSystemApiRelativeUrl
};
//# sourceMappingURL=formatSystemApiRelativeUrl.js.map
